module.exports = __webpack_public_path__ + "static/media/Roboto-ThinItalic.d687b55c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-ThinItalic.ttf
// module id = 518
// module chunks = 0